<ion-item lines="none" *ngIf="showError && field.formControl?.errors">
  <ion-label>
    <ion-text color="danger">
      <p>
        <formly-validation-message [field]="field"></formly-validation-message>
      </p>
    </ion-text>
  </ion-label>
</ion-item>
